import {
    LIST_LEVELS,
    LIST_LEVELS_SUCCESS,
    LIST_LEVELS_ERROR,
    ADD_LEVELS,
    SAVE_LEVELS,
    SAVE_LEVELS_SUCCESS,
    SAVE_LEVELS_ERROR,
    EDIT_LEVELS,
    UPDATE_LEVELS,
    UPDATE_LEVELS_SUCCESS,
    UPDATE_LEVELS_ERROR,
    DELETE_LEVELS,
    DELETE_LEVELS_SUCCESS,
    DELETE_LEVELS_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    levels: null,
    error: null,
    loading: false,
    levelSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_LEVELS:
            return {
                ...state,
                loading: true
            }
        case LIST_LEVELS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_LEVELS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                levels: action.payload
            }
        case SAVE_LEVELS:
        case DELETE_LEVELS:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_LEVELS:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_LEVELS_ERROR:
        case UPDATE_LEVELS_ERROR:
        case DELETE_LEVELS_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_LEVELS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                levels: [...state.levels, action.payload]
            }
        case ADD_LEVELS:
            return {
                ...state,
                levelSelected: null,
                isEdit: false
            }
        case EDIT_LEVELS:
            return {
                ...state,
                levelSelected: action.payload,
                isEdit: true
            }
        case UPDATE_LEVELS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                levels: state.levels.map(level => 
                    level.id === action.payload.id ? level = action.payload : level
                ),
                levelSelected: null
            }
        case DELETE_LEVELS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                levels: state.levels.filter( level => level.id !== action.payload)
            }
        default:
            return state;
    }
}